import { CommonModule }         from '@angular/common';
import { NgModule }             from '@angular/core';
import { ActionItemModule }     from '@shared/components/action-item/action-item.module';
import { EntityMessagesModule } from '@shared/components/entity/entity-messages/entity-messages.module';
import { StatusFlowComponent }  from './status-flow.component';


@NgModule( {
	declarations: [
		StatusFlowComponent
	],
	imports: [
		// Angular
		CommonModule,

		// Shared
		ActionItemModule,

		// Entity
		EntityMessagesModule
	],
	exports: [
		StatusFlowComponent
	]
} )
export class StatusFlowModule {}
